import { findAgentByInternalName } from '@/store/modules/cosmoClaw'

// 供应链数字人内部名称
export const SUPPLY_CHAIN_INTERNAL_NAME = 'gong_ying_lian_shu_zi_ren'

/**
 * 从已加载的智能体列表（agentList）中直接取供应链数字人头像
 * （与数字人档案页 icon 同源：agentList.icon）
 */
export function getSupplyChainAvatar(agentList) {
  const agent = findAgentByInternalName(SUPPLY_CHAIN_INTERNAL_NAME, agentList || [])
  return (agent && (agent.icon || agent.iconUrl)) || ''
}
